// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniReferralCodes_container__2YHRH"};